import type { AnchorHTMLAttributes, ImgHTMLAttributes } from "react";
import { useRef } from "react";
import { useLocalAsset } from "./useLocalAsset";

// <img> that shows the downloaded copy when the module has been saved to
// this device. See useLocalAsset.
//
// When the picture changes (the next slide, the next gallery image) the lookup
// takes a moment and reports nothing. Taking the src away then would blank the
// picture for that moment, a visible blink, so the previous one stays on screen
// until the new one is ready.
export function LocalImg({ src, alt, ...rest }: ImgHTMLAttributes<HTMLImageElement>) {
  const local = useLocalAsset(src);
  const shown = useRef<string | undefined>(undefined);
  if (local !== undefined) shown.current = local;
  return <img {...rest} src={local ?? shown.current} alt={alt} />;
}

// File link that opens the downloaded copy when there is one. A blob: URL
// has no file name of its own, so the download attribute supplies it.
export function LocalLink({
  href,
  fileName,
  ...rest
}: AnchorHTMLAttributes<HTMLAnchorElement> & { fileName?: string }) {
  const local = useLocalAsset(href);
  const isLocal = Boolean(local?.startsWith("blob:"));
  return <a {...rest} href={local ?? href} download={isLocal ? fileName || true : undefined} />;
}
